import { Injectable } from '@angular/core';
import { Form, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ValidationUtilService } from 'app/BaseFramework/core/services/validations/validationsUtil.service';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';

@Injectable({
  providedIn: 'root'
})
export class FormCrudService {

  private ignoreValidationFields = {
    // State: List Of Field to Ignore
  }
  private transactionState

  constructor(private validationUtilService: ValidationUtilService,
    private commonUtilty: CommonUtilty,
    private fb: FormBuilder) { }

  formFactory(metaData: any, FormName: string, dataObject = {}): FormGroup {
    let formDataOutput = {}
    if (metaData && Array.isArray(metaData)) {
      metaData.forEach(field => {
        let initialValue
        if (field.fieldType == 'DATE') {
          initialValue = this.commonUtilty.serverDOtoUIDODate(dataObject[field.fieldKey]) || this.commonUtilty.serverDOtoUIDODate(field.defaultValue)
        }
        else if (field.fieldType == 'TIME') {
          initialValue = this.commonUtilty.serverDOtoUIDOsetTime(dataObject[field.fieldKey]) || this.commonUtilty.serverDOtoUIDOsetTime(field.defaultValue)
        }
        else if (field.fieldType == 'COMBOMULTISELECTCSV') {
          initialValue = this.commonUtilty.convertCSVToArray(dataObject[field.fieldKey]) || this.commonUtilty.convertCSVToArray(field.defaultValue)
        }
        else {
          initialValue = dataObject[field.fieldKey] || field.defaultValue
        }
        formDataOutput[field.fieldKey] = this.validationUtilService.setValidationsForFormControl(
          field.fieldKey, FormName, initialValue, null, field.validationList)
      })
    }

    let output = this.fb.group(formDataOutput)

    return output
  }

  checkInvalidAndEmptyFields(form: FormGroup, componentName, formMetaData) {
    let invalidFields = [];
    let FormFieldNameMap = this.commonUtilty.convertArrayToMap(formMetaData, 'fieldKey')
    if (form && !form.valid) {
      for (const i in form.controls) {
        let controlName = this.commonUtilty.getControlName(form.controls[i])
        let validationErrorList = this.validationUtilService.getUIErrorList(form.get(controlName), formMetaData.fieldKey)
        if (form.controls[i].status === 'INVALID') {
          validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = validationError.errorMessage;
            errorDO.validationLevel = validationError.validationLevel
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = FormFieldNameMap[controlName].fieldName
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          })
        }
      }
    }
    if (this.ignoreValidationFields[this.transactionState] && this.commonUtilty.isArrayIterable(this.ignoreValidationFields[this.transactionState])) {
      let tempArray = [];
      invalidFields.forEach(invalidField => {
        if (!this.ignoreValidationFields[this.transactionState].includes(invalidField.fieldName))
          tempArray.push(invalidField);
      });
      invalidFields = tempArray;
    }
    return invalidFields;
  }

  initRowForm(metaData, data, index?): FormGroup {
    let payload = data || {}
    let formObject = this.formFactory(metaData.columns, metaData.controlId, payload)
    if (typeof index == 'number') {
      formObject.addControl('index', this.validationUtilService.setValidationsForFormControl('index', metaData.controlId, index))
      formObject.addControl('fieldMetaData', this.validationUtilService.setValidationsForFormControl('fieldMetaData', metaData.controlId, metaData))
    }
    return formObject
  }

  addRow(form: FormGroup, formArrayKeyName: string, metaDataConfig: any, data?) {
    let dataForEdit = data || {}
    const control = <FormArray>form.get(formArrayKeyName);
    control.push(this.initRowForm(metaDataConfig, dataForEdit, control.value.length));
    return form
  }

  removeRow(form: FormGroup, formArrayKeyName: string, index: number): FormGroup {
    const control = <FormArray>form.get(formArrayKeyName);
    let removeItem = form.value[formArrayKeyName][index]
    control.removeAt(index);
    return form
  }

  setValueOnGrid(form: FormGroup, formArrayKeyName: string, index, fieldKey, fieldValue): FormGroup {
    try {
      const controlList = <FormArray>form.get(formArrayKeyName);
      const parentControl = <FormControl>controlList.controls[index]['controls'][fieldKey]
      parentControl.setValue(fieldValue)
      return form
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  getValueFromGrid(form: FormGroup, formArrayKeyName: string, index, fieldKey): any {
    try {
      const controlList = <FormArray>form.get(formArrayKeyName);
      const parentControl = <FormControl>controlList.controls[index]
      return parentControl.value[fieldKey]
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }

  resetValueOnGrid(form: FormGroup, formArrayKeyName: string, index, fieldKey) {
    try {
      const controlList = <FormArray>form.get(formArrayKeyName);
      const parentControl = <FormControl>controlList.controls[index]['controls'][fieldKey]
      return parentControl.reset()
    }
    catch {
      console.warn(`Minor issue on form Detected`)
    }
  }
}
